require('./js/main');
require('./scss/main.scss');
let ctx = require.context('./js/lib', false, /\.ts|js$/);
ctx.keys().forEach(ctx);